import React from 'react';

export function ExternalLink() {
    return (
        <svg height="10" viewBox="0 0 1021 1021" width="10" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="currentColor"
                d="M689.852 213.122h-647.492c0 0-42.359 14.336-42.359 48.411s0 714.057 0 714.057c0 0 0.006 48.411 42.359 48.411s714.057 0 714.057 0c0 0 54.462-16.895 54.462-60.513s-6.051-665.646-6.051-665.646l-121.027 139.181c0 0 12.103 88.604 12.103 193.643 0 138.406-12.103 284.413-12.103 284.413s-137.861 6.051-290.464 6.051c-146.829 0-278.361-12.103-278.361-12.103s-19.727-148.215-18.154-302.566c1.446-141.619 24.205-266.259 24.205-266.259s119.024-18.154 242.053-18.154c109.112 0 211.797 12.103 211.797 12.103l114.975-121.027z"
            ></path>
            <path
                fill="currentColor"
                d="M429.644 485.432c-41.712 77.348 72.138 153.22 127.078 102.873 23.86-21.863 54.48-91.623 163.386-229.951 92.428-117.402 175.24-181.649 175.489-181.54 0 0 9.343 108.143 6.051 169.437-2.844 52.979-23.86 105.693-30.257 139.181-6.826 35.727 153.837 78.165 139.181-6.051-5.567-31.987-20.417-107.532-18.154-187.591 2.929-103.617 24.205-211.797 24.205-211.797s28.211-91.708-60.513-78.667c-33.839 4.974-140.875 23.413-236.002 24.205-75.442 0.629-143.011-15.51-163.386-18.154-65.015-8.442-80.029 134.091-6.051 127.078 26.934-2.554 76.059-13.694 121.027-12.103 63.267 2.233 151.283-6.051 151.283-6.051s-61.657 76.162-175.489 175.489c-128.367 112.004-196.051 153.22-217.848 193.643z"
            ></path>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/components/Login/ExternalLink.js